import clsx from 'clsx';

import { getPlayerName } from '../../utils/misc';
import type { HistoricalData } from '../../utils/types';

import TeamFlag from '@shared/MatchUnit/utils/TeamFlag';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const DoublePlayerCarouselCard = ({
  data: { cardType, cardImg, season, goalScored, topScorers },
  language,
}: {
  data: HistoricalData;
  language: string;
}) => {
  const t = useTranslateFn();
  return (
    <div className={clsx(styles.tsHistoricalCarouselCard, styles[cardType])}>
      <img src={cardImg} alt='players' />
      <div className={styles.tsHistoricalCarouselCardCompetitionLogo} />
      <div className={styles.tsHistoricalCarouselCardSeasonYear}>{season}</div>
      <div className={styles.tsHistoricalCarouselCardPlayerInfo}>
        {!!topScorers[0]?.team && (
          <TeamFlag
            className={clsx(styles.tsHistoricalCarouselCardFlag, styles.teamFlag, styles.player1)}
            team={topScorers[0].team}
          />
        )}
        {!!topScorers[1]?.team && (
          <TeamFlag
            className={clsx(styles.tsHistoricalCarouselCardFlag, styles.teamFlag, styles.player1)}
            team={topScorers[1].team}
          />
        )}
        <div className={styles.tsHistoricalCarouselCardPlayer1}>
          <div className={styles.tsHistoricalCarouselCardPlayerName}>{getPlayerName(topScorers[0], language)}</div>
        </div>
        <div>
          <div className={styles.tsHistoricalCarouselCardPlayerName}>{getPlayerName(topScorers[1], language)}</div>
        </div>
        <div className={styles.tsHistoricalCarouselCardGoals}>
          {goalScored} {t('stats_goals')}
        </div>
      </div>
    </div>
  );
};

export default DoublePlayerCarouselCard;
